import { Component, Input, OnInit } from '@angular/core';
import { APlayFromSchedule24, TPlayer } from '../../../store/actions';
import { PlayerStatus } from '../../../store/entities';
import { NgRedux } from '@angular-redux3/store';
import { PlaylistRemoteAppState } from '../../../store';
import { ActivatedRoute } from '@angular/router';
import { SyncDialogService } from '../../../services/sync-dialog.service';

@Component({
  selector: 'mwo-play-from',
  templateUrl: './play-from.component.html',
  styleUrls: ['./play-from.component.scss']
})
export class PlayFromComponent implements OnInit {
  @Input() context: string;
  private playerId: string;

  constructor(private ngRedux: NgRedux<PlaylistRemoteAppState>,
              private route: ActivatedRoute, private syncDialogService: SyncDialogService) { }

  ngOnInit(): void {
    this.ngRedux.select<PlayerStatus>('player').subscribe(({ player }) => {
      if (player && player.id) {
        this.playerId = player.id;
      }
    });
  }

  play() {
    this.ngRedux.dispatch(APlayFromSchedule24({
      player: {
          id: this.playerId
        },
        playerContextType: this.context,
        type: TPlayer.PLAY_FROM
      }));
    this.syncDialogService.openSyncDialog('SCHEDULE');
  }
}
